const InputStyle = {
  FullWidth: 'fullWidth',
  LoginRegister: 'loginRegister',
  Default: '_default',
};

export default InputStyle;
